import { render, staticRenderFns } from "./ApplicationComplianceTab.vue?vue&type=template&id=6c2993b8&"
import script from "./ApplicationComplianceTab.vue?vue&type=script&lang=js&"
export * from "./ApplicationComplianceTab.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationComplianceTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports